module.exports = __webpack_public_path__ + "img/00banner pink.837b4890.webp";